export const ApiError = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="bg-alert-100 border border-alert-400 rounded px-3 py-2">
      {children}
    </div>
  );
};
